// Federal regulation 42 CFR Part 2
export const ALLOWED_42CFRP2_EMAIL_DOMAINS = [
  "mvphealthcare.com",
  "cdphp.com",
  "masterborn.com", // development/qa team
];
